import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { SalaryDraftFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const SalaryDraftRejectForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<SalaryDraftFormTypes.Reject>
      formRef={ref}
      {...props}
      fields={{
        message: {
          label: TranslationKeys.Salary.SalaryDraftRejectFormMessage,
          type: FormEnums.FormFieldType.TEXTAREA,
        },
      }}
    />
  );
};

export default forwardRef(SalaryDraftRejectForm);
